import { HttpClient } from '../HttpClient';

/**
 * Update user setting language for an employee
 */
export const UpdateUserSettingLanguage = async (employeeId, languageInput) => {
  try {
    const { data } = await HttpClient.put(`api/usersettings/${employeeId}/Language`, languageInput);
    return data;
  } catch (err) {
    throw new Error(err.message || 'Failed to update user setting language');
  }
};
